// extracted by mini-css-extract-plugin
export default {"box":"GradeModal_box__pcNaG","name":"GradeModal_name__vr2VO","rateList":"GradeModal_rateList__UjYun","userItem":"GradeModal_userItem__fQVEh"};